"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2249],{

/***/ 86691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ OpendoorLogoBadge; },
/* harmony export */   "o": function() { return /* binding */ OpendoorLogo; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78049);

var OpendoorLogo = function(param) {
    var _width = param.width, width = _width === void 0 ? "256px" : _width;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "256",
        height: "56",
        viewBox: "0 0 256 56",
        fill: "none",
        style: {
            height: "auto",
            maxWidth: "100%",
            width: width
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
            d: "M154.378 38.5472L154.378 38.5473C153.466 38.9528 152.132 39.5455 150.289 39.5455C146.07 39.5455 143.85 36.6648 143.85 27.7977C143.85 18.4782 146.626 15.4851 150.622 15.4851C152.677 15.4851 154.009 16.671 154.952 17.857V38.3027C154.783 38.3671 154.592 38.452 154.378 38.5472ZM163.778 7.69108C163.778 4.7717 163.876 2.08934 163.928 0.988439C163.943 0.66633 163.674 0.407602 163.359 0.436253L155.364 1.36004C155.131 1.38131 154.952 1.57969 154.952 1.81802V9.72444C154.952 11.7574 155.063 13.8472 155.063 13.8472C153.898 13.5081 152.343 13.226 150.845 13.226C142.185 13.226 134.746 17.9139 134.746 29.6617C134.746 39.9406 140.13 44.0073 145.626 44.0073C149.512 44.0073 152.621 42.4258 155.008 40.3365H155.23L155.117 43.4538C155.104 43.7859 155.389 44.0485 155.712 44.0021L163.328 43.1369C163.586 43.1004 163.778 42.8756 163.778 42.6103V7.69108ZM18.6517 5.8832C24.7573 5.8832 26.9781 11.3616 26.9781 24.5776C26.9781 37.8501 24.3691 41.6346 18.8736 41.6346C12.6562 41.6346 10.5468 36.2122 10.5468 23.0531C10.5468 9.72376 13.2668 5.8832 18.6517 5.8832ZM18.985 3.51123C10.0471 3.51123 0 9.38472 0 24.239C0 37.7941 8.99286 44.0066 18.5399 44.0066C27.4778 44.0066 37.5249 38.302 37.5249 23.3352C37.5249 9.32872 28.5325 3.51123 18.985 3.51123ZM50.4951 39.7148C51.4948 40.9007 52.9932 41.7481 54.8808 41.7481C59.2661 41.7481 61.5978 39.3761 61.5978 29.04C61.5978 20.9634 59.2106 18.1396 54.9917 18.1396C53.0406 18.1396 51.7322 18.6632 50.8408 19.0199L50.8406 19.02L50.8402 19.0202C50.7175 19.0693 50.6026 19.1153 50.4951 19.1562V39.7148ZM50.4951 17.1233C52.8273 15.0899 55.9351 13.2263 59.8212 13.2263C65.0948 13.2263 70.7012 16.7843 70.7012 27.12C70.7012 38.8678 63.9291 44.0072 54.6589 44.0072C53.4933 44.0072 51.6612 43.7815 50.4401 43.4429C50.4401 43.4429 50.4951 44.9115 50.4951 46.888V52.0413V54.5539C50.4951 54.7879 50.3227 54.9845 50.0945 55.0106L42.1713 55.9213C41.9033 55.9522 41.6691 55.7386 41.6691 55.4646V52.0413V14.5686C41.6691 14.3346 41.8414 14.1379 42.0701 14.1115L49.7732 13.2255C50.0736 13.1907 50.3347 13.436 50.3249 13.7438L50.2178 17.1233H50.4951ZM82.7352 25.1992L92.2272 24.6908C92.2272 17.8571 91.3398 15.3718 88.0088 15.3718C85.1774 15.3718 82.957 18.0828 82.7352 25.1992ZM73.9646 28.5314C73.9646 18.704 81.1249 13.2256 88.4525 13.2256C96.0237 13.2256 100.775 17.0314 101.046 26.9886C101.051 27.1822 100.896 27.3454 100.705 27.3454H83.0837C82.8926 27.3454 82.7382 27.5086 82.7428 27.7027C82.9912 36.674 86.4173 39.1497 92.0608 39.1497C94.8154 39.1497 97.0362 38.4985 98.8947 37.6598C99.0317 37.5977 99.1904 37.6342 99.2881 37.7505L100.026 38.634C100.138 38.7672 100.136 38.9643 100.019 39.0911C97.9936 41.2638 93.8712 44.0069 88.4525 44.0069C78.7936 44.0069 73.9646 38.133 73.9646 28.5314ZM113.208 17.236C116.149 15.0902 119.813 13.2262 123.865 13.2262C128.584 13.2262 131.138 15.7114 131.138 20.7948V42.8819C131.138 43.1293 130.94 43.3294 130.697 43.3294H122.696C122.453 43.3294 122.256 43.1293 122.256 42.8819V22.9971C122.256 19.552 121.034 18.4789 118.426 18.4789C116.482 18.4789 114.484 18.9303 113.263 19.2129V42.8819C113.263 43.1293 113.065 43.3294 112.823 43.3294H104.876C104.634 43.3294 104.437 43.1293 104.437 42.8819V14.568C104.437 14.334 104.609 14.1378 104.838 14.1117L112.606 13.2157C112.872 13.1854 113.103 13.402 113.094 13.675L112.985 17.236H113.208ZM182.333 15.4283C186.108 15.4283 188.273 17.5745 188.273 28.9833C188.273 39.8273 185.998 41.8038 182.666 41.8038C178.614 41.8038 176.782 39.3194 176.782 27.7409C176.782 18.0264 178.836 15.4283 182.333 15.4283ZM182.5 13.2256C175.006 13.2256 167.457 17.8567 167.457 28.7011C167.457 39.0364 174.451 44.0074 182.5 44.0074C190.161 44.0074 197.599 39.2626 197.599 28.4185C197.599 18.1393 190.549 13.2256 182.5 13.2256ZM221.382 28.9833C221.382 17.5745 219.218 15.4283 215.443 15.4283C211.945 15.4283 209.892 18.0264 209.892 27.7409C209.892 39.3194 211.724 41.8038 215.776 41.8038C219.107 41.8038 221.382 39.8273 221.382 28.9833ZM200.565 28.7011C200.565 17.8567 208.115 13.2256 215.609 13.2256C223.658 13.2256 230.708 18.1393 230.708 28.4185C230.708 39.2626 223.27 44.0074 215.609 44.0074C207.56 44.0074 200.565 39.0364 200.565 28.7011ZM243.234 17.5745C244.954 15.7109 248.118 13.2256 251.338 13.2256C254.002 13.2256 255.883 14.6937 255.883 17.4616C255.883 20.1726 253.947 21.9186 251.782 21.9186C249.397 21.9186 248.562 20.9067 247.508 19.1559C247.175 18.5347 246.841 18.4214 246.341 18.4214C245.343 18.4214 244.066 19.1559 243.289 19.8905V42.7975C243.289 43.091 243.054 43.3288 242.766 43.3288H234.985C234.696 43.3288 234.463 43.091 234.463 42.7975V14.5683C234.463 14.3339 234.635 14.1376 234.864 14.1116L242.539 13.2351C242.854 13.1991 243.129 13.4561 243.119 13.7791L243.011 17.5745H243.234Z",
            fill: "currentColor"
        })
    });
};
var OpendoorLogoBadge = function(param) {
    var _width = param.width, width = _width === void 0 ? "14px" : _width;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "20",
        viewBox: "0 0 14 20",
        fill: "none",
        style: {
            height: "auto",
            maxWidth: "100%",
            width: width
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.0652 7.72525C10.0652 2.87886 9.23666 0.869951 6.95864 0.869951C4.94968 0.869951 3.93488 2.27822 3.93488 7.16613C3.93488 11.9918 4.7219 13.9801 7.04144 13.9801C9.09177 13.9801 10.0652 12.5924 10.0652 7.72525ZM0 7.60107C0 2.15396 3.74854 0 7.08288 0C10.645 0 14 2.13332 14 7.26967C14 12.7581 10.2515 14.85 6.91711 14.85C3.35507 14.85 0 12.5718 0 7.60107ZM13.2689 19.2321C12.929 18.7812 11.6198 17.0442 11.6198 17.0442C11.4969 16.8812 11.2864 16.7829 11.0605 16.7829H2.93952C2.71362 16.7829 2.50312 16.8812 2.38028 17.0442L0.731324 19.2318C0.679012 19.3011 0.651254 19.3819 0.651254 19.4645V19.7984C0.651254 19.9098 0.741489 20 0.852838 20H13.1472C13.2585 20 13.3488 19.9098 13.3488 19.7984V19.4645C13.3488 19.3819 13.3213 19.3014 13.2689 19.2321Z",
            fill: "currentColor"
        })
    });
};


/***/ }),

/***/ 43274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ trapFocus; }
/* harmony export */ });
var trapFocus = function(e, containerRef) {
    var ref;
    if (e.key !== "Tab") return;
    var containerElements = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var firstElement = containerElements && containerElements[0];
    var lastElement = containerElements && containerElements[containerElements.length - 1];
    // tabbing forwards on the last element (Careers)
    if (!e.shiftKey && document.activeElement === lastElement) {
        firstElement.focus();
        return e.preventDefault();
    }
    // tabbing backwards on the first element (Close button)
    if (e.shiftKey && document.activeElement === firstElement) {
        lastElement.focus();
        e.preventDefault();
    }
};


/***/ }),

/***/ 63080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var _chunks_use_impression_ref_k081rlv0dt8gci3d_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74637);
/* harmony import */ var _chunks_cn_dk9nmc4mhy1765ud_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27739);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31549);
"use client";







//#region src/components/text/text.tsx
/**
* Typography component. Both typography and color are applied with Tailwind
* utility classes via `className` — there are no `variant`, `size`, or `color`
* props. Pick a step from the OD ramp (`text-{display,header,subheader,body,label}-{size}`)
* and a semantic color token (`text-od-content-*`).
*
* Use `as` to choose the rendered element (defaults to `<p>`); `as="label"`
* additionally accepts `htmlFor`. For truncation, add the `truncate` class
* (plus `min-w-0` inside flex/grid) via `className`.
*
* @example
* ```tsx
* <Text as="h1" className="text-header-lg">Page title</Text>
* <Text as="h2" className="text-subheader-md">Section</Text>
* <Text className="text-body-md">Default body copy</Text>
* <Text className="text-body-sm text-od-content-tertiary">Helper text</Text>
* <Text as="label" htmlFor="email" className="text-label-md">Form label</Text>
* <Text className="text-body-md truncate min-w-0">Clipped…</Text>
* ```
*/ function TextInner(_param, ref) {
    var children = _param.children, className = _param.className, as = _param.as, analyticsName = _param.analyticsName, trackImpression = _param.trackImpression, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "as",
        "analyticsName",
        "trackImpression"
    ]);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(as !== null && as !== void 0 ? as : "p", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: (0,_chunks_use_impression_ref_k081rlv0dt8gci3d_js__WEBPACK_IMPORTED_MODULE_5__.t)(Boolean(analyticsName && trackImpression), analyticsName, "textViewEvent", ref),
        className: (0,_chunks_cn_dk9nmc4mhy1765ud_js__WEBPACK_IMPORTED_MODULE_6__.t)("m-0", className)
    }, props), {
        children: children
    }));
}
/**
* Typography primitive for all text in the OD design language. Typography and
* color are applied with Tailwind utility classes via `className` — pick a step
* from the OD ramp (`text-{display,header,subheader,body,label}-{size}`) and a
* semantic color token (`text-od-content-*`).
*
* Use `as` to choose the rendered element (defaults to `<p>`); `as="label"`
* additionally accepts `htmlFor`. Set `analyticsName` (plus `trackImpression`)
* to emit a view event the first time it scrolls into view.
*
* @example
* ```tsx
* <Text as="h1" className="text-header-lg">Page title</Text>
* <Text className="text-body-md">Default body copy</Text>
* <Text className="text-body-sm text-od-content-tertiary">Helper text</Text>
* <Text as="label" htmlFor="email" className="text-label-md">Email</Text>
* ```
*/ var Text = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(TextInner);
//#endregion



/***/ }),

/***/ 22901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Box; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77453);
/* harmony import */ var _helpers_tokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74609);







// default styling for View: https://github.com/tamagui/tamagui/blob/1ded484e5e47fd05a1a49b4dd8e315c0baaa678d/packages/web/src/constants/constants.ts#L1-L20
// flex direction defaults to column rather than row
var BaseBox = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.View, {
    name: "Box",
    tag: "div",
    variants: {
        shadow: function(shadowToken) {
            return (0,_helpers_tokens__WEBPACK_IMPORTED_MODULE_2__/* .getShadowProps */ .dh)(shadowToken);
        }
    }
});
/**
 * Box is an abstract styled component that can be used as a generic container.
 * On web, it renders a `<div>` element by default, but it can be made to render
 * other elements like `<span>` by providing a `tag` prop. Some important things
 * to note:
 * - Box defaults to `display: flex` with `flexDirection` set to `column` for
 *   both web and native. This comes from Tamagui and is intended to ensure
 *   consistency across platforms. Tamagui also adds defaults for other flex
 *   props like `flexShrink` and `flexGrow` for the same reason. If you're
 *   taking a mobile-first approach, these defaults will mostly make sense, but
 *   they should be overridden as needed. Remember that you can also use media
 *   query props like `$largerThanSM` to set prop values for specific screen
 *   sizes.
 * - For a11y reasons, Box does not support press handlers like `onPress`. If
 *   you need a box that can be pressed and act like either a button or a link,
 *   use `PressableBox` instead.
 * - If you want to use `display: grid`, nest the `display` prop underneath
 *   `$platform-web`. (Tamagui doesn't let you pass "grid" to the regular
 *   `display` prop because grid is only relevant for web, not native.)
 *   Here's an example:
 *   `<Box $platform-web={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gridTemplateRows: '120px' }} />`
 */ var Box = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function Box(_param, ref) {
    var analyticsName = _param.analyticsName, _trackImpression = _param.trackImpression, trackImpression = _trackImpression === void 0 ? false : _trackImpression, inViewThreshold = _param.inViewThreshold, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "trackImpression",
        "inViewThreshold"
    ]);
    var BaseBoxWithProps = /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(BaseBox, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref
    }, props));
    if (analyticsName && trackImpression) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_helpers_analytics__WEBPACK_IMPORTED_MODULE_6__/* .ComponentWithViewTracking */ .o, {
            Component: BaseBoxWithProps,
            analyticsName: analyticsName,
            eventName: "boxViewEvent",
            inViewThreshold: inViewThreshold,
            ref: ref
        });
    }
    return BaseBoxWithProps;
});


/***/ }),

/***/ 34984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Row; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36690);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22901);




/**
 * Row is a convenience component that renders a Box with flexDirection set to 'row'.
 * It accepts all the same props as Box.
 */ var Row = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function Row(props, ref) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Box__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        flexDirection: "row"
    }, props));
});


/***/ }),

/***/ 77453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ComponentWithViewTracking; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99758);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98378);
/* harmony import */ var react_native__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73561);
/* harmony import */ var _useObservabilitySafe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26217);








/**
 * This hook is used to track component in view events. It is used to track the first time a component enters the viewport.
 * @param eventName - The event name to track
 * @param analyticsName - The name of the component to track
 * @returns A ref to be passed to the component which is used to trigger the inView event
 */ var useTrackComponentInViewForWeb = function(eventName, analyticsName, options) {
    var trackJourneyEvent = (0,_useObservabilitySafe__WEBPACK_IMPORTED_MODULE_1__/* .useObservabilitySafe */ .r)().trackJourneyEvent;
    // Tracks impression events
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .YD)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        // https://react-intersection-observer.vercel.app/?path=/docs/useinview-hook--basic
        // threshold: Number between 0 and 1 indicates the percentage that should be visible
        // before triggering. (defaults to 100% unless an override is provided)
        threshold: 1,
        skip: !analyticsName,
        triggerOnce: true
    }, options)), 2), inViewRef = ref[0], inView = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // this tracks impression events whenenver the component enters or leaves the viewport
        if (inView) {
            trackJourneyEvent("platform", eventName, {
                targetName: analyticsName
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        inView,
        analyticsName
    ]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return inViewRef;
    }, [
        inViewRef
    ]);
};
var WebComponentWithViewTracking = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function WebComponentWithViewTracking(props, ref) {
    var Component = props.Component, analyticsName = props.analyticsName, eventName = props.eventName, inViewThreshold = props.inViewThreshold;
    var inViewRef = useTrackComponentInViewForWeb(eventName, analyticsName, {
        threshold: inViewThreshold
    });
    var ComponentWithViewTracking = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(Component, {
        ref: (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_5__.useComposedRefs)(inViewRef, ref)
    });
    return ComponentWithViewTracking;
});
/**
 *
 * Solution inspired by code here: https://github.com/SvanBoxel/visibility-sensor-react-native/blob/master/src/index.tsx
 */ var MobileComponentWithViewTracking = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function MobileComponentWithViewTracking(props, _ref) {
    var Component = props.Component, analyticsName = props.analyticsName, eventName = props.eventName;
    var inViewThreshold = props.inViewThreshold || 1;
    var trackJourneyEvent = (0,_useObservabilitySafe__WEBPACK_IMPORTED_MODULE_1__/* .useObservabilitySafe */ .r)().trackJourneyEvent;
    var inViewRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), trackedInView = ref[0], setTrackedInView = ref[1];
    var interval = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var startWatching = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (interval.current || trackedInView) {
            return;
        }
        interval.current = setInterval(function() {
            var // gets the dimension of the component and determines if it is in view
            ref;
            if (!inViewRef || !inViewRef.current) {
                return;
            }
            (ref = inViewRef.current) === null || ref === void 0 ? void 0 : ref.measure(function(_x, _y, width, height, pageX, pageY) {
                // console.log('analyticsName', analyticsName)
                var window = react_native__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("window");
                if (height > window.height || width > window.width) {
                    // auto updates inViewThreshold to ensure component will be tracked if it's larger than the window
                    inViewThreshold = (height > window.height ? window.height / height : window.width / width) - 0.01;
                }
                var componentHeight = height * inViewThreshold;
                var componentWidth = width * inViewThreshold;
                var rectBottom = pageY + componentHeight;
                var rectTop = pageY;
                var rectRight = pageX + componentWidth;
                var isVisible = rectBottom !== 0 && // Check if the bottom edge is not at the top (initialized value)
                rectTop >= 0 && // Check if the top edge is greater than or equal to the top of the viewport
                rectBottom <= window.height && // Check if the bottom edge is within the inViewThreshold percentage of the viewport height
                rectRight >= 0 && // Check if the width is greater than 0 (initialized value)
                rectRight <= window.width; // Check if the width is within the inViewThreshold percentage of the viewport width
                if (trackedInView !== isVisible) {
                    // only track the component the first time it enters the viewport
                    setTrackedInView(isVisible);
                    trackJourneyEvent("platform", eventName, {
                        targetName: analyticsName
                    });
                }
            });
        }, 300);
    }, [
        trackedInView,
        inViewThreshold,
        trackJourneyEvent,
        eventName,
        analyticsName
    ]);
    var stopWatching = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (interval.current) {
            clearInterval(interval.current);
            interval.current = null;
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // We don't care about watching after the component has already been in view
        if (!trackedInView) {
            startWatching();
        }
        return stopWatching;
    }, [
        startWatching,
        stopWatching,
        trackedInView
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_tamagui_core__WEBPACK_IMPORTED_MODULE_5__.View, {
        ref: inViewRef,
        // add collapsable-false to ensure view stays in the native view hierarchy for android
        // https://reactnative.dev/docs/view#collapsable-android
        collapsable: false,
        children: Component
    });
});
var ComponentWithViewTracking = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function ComponentWithViewTracking(props, ref) {
    var Component = props.Component, analyticsName = props.analyticsName, eventName = props.eventName, inViewThreshold = props.inViewThreshold;
    if (_tamagui_core__WEBPACK_IMPORTED_MODULE_5__.isWeb) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(WebComponentWithViewTracking, {
            Component: Component,
            analyticsName: analyticsName,
            eventName: eventName,
            inViewThreshold: inViewThreshold,
            ref: ref
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(MobileComponentWithViewTracking, {
        Component: Component,
        analyticsName: analyticsName,
        eventName: eventName,
        inViewThreshold: inViewThreshold,
        ref: ref
    });
});


/***/ }),

/***/ 770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ls": function() { return /* binding */ getRGBA; }
/* harmony export */ });
/* unused harmony exports hex, shortToLongHex, getR, getG, getB, getRGB */
var hex = function(x) {
    return x.toString(16).length === 1 ? "0" + x.toString(16) : x.toString(16);
};
var shortToLongHex = function(hex) {
    var r = hex.substring(1, 2);
    var g = hex.substring(2, 3);
    var b = hex.substring(3);
    return "#".concat(r).concat(r).concat(g).concat(g).concat(b).concat(b);
};
var getR = function(c) {
    return parseInt(c.substring(1, 3), 16);
};
var getG = function(c) {
    return parseInt(c.substring(3, 5), 16);
};
var getB = function(c) {
    return parseInt(c.substring(5), 16);
};
var getRGB = function(hex) {
    if (hex.length === 4) {
        hex = shortToLongHex(hex);
    }
    return "rgb(".concat(getR(hex), ", ").concat(getG(hex), ", ").concat(getB(hex), ")");
};
var getRGBA = function(hex, opacity) {
    if (hex.length === 4) {
        hex = shortToLongHex(hex);
    }
    return "rgba(".concat(getR(hex), ", ").concat(getG(hex), ", ").concat(getB(hex), ", ").concat(opacity, ")");
};


/***/ }),

/***/ 74609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GJ": function() { return /* binding */ getStateTokenValue; },
/* harmony export */   "Re": function() { return /* binding */ getPercentageTokenValue; },
/* harmony export */   "dh": function() { return /* binding */ getShadowProps; },
/* harmony export */   "vs": function() { return /* binding */ getOpacityTokenValue; }
/* harmony export */ });
/* unused harmony exports getRadiusTokenValue, getSizeTokenValue, getSpaceTokenValue */
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _convertColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(770);


var getRadiusTokenValue = function(radiusToken) {
    var tokens = getTokens();
    return tokens.radius[radiusToken].val;
};
var getSizeTokenValue = function(sizeToken) {
    var tokens = getTokens();
    return tokens.size[sizeToken].val;
};
var getSpaceTokenValue = function(spaceToken) {
    var tokens = getTokens();
    return tokens.space[spaceToken].val;
};
// Tamagui doesn't currently use our opacity tokens for type-checking opacity props,
// so instead of `<View opacity={opacityToken} />`, we have to do
// `<View opacity={getOpacityTokenValue(opacityToken)} />`. Look into upgrading Tamagui
// and using the `acceptsTokens` config option to add this type-checking. See:
// https://tamagui.dev/docs/core/styled#custom-props-that-accepts-tokens-with-accepttokens
var getOpacityTokenValue = function(opacityToken) {
    var tokens = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getTokens)();
    return tokens.opacity[opacityToken].val;
};
var getStateTokenValue = function(stateToken) {
    var tokens = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getTokens)();
    return tokens.state[stateToken].val;
};
var getShadowProps = function(shadowToken) {
    var tokens = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getTokens)();
    var shadowOpacity = tokens.shadowOpacity[shadowToken].val;
    // shadowOpacity doesn't seem to work on web, so use rgba to get the same effect
    var shadowColor = _tamagui_core__WEBPACK_IMPORTED_MODULE_0__.isWeb ? (0,_convertColor__WEBPACK_IMPORTED_MODULE_1__/* .getRGBA */ .ls)((0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getTokenValue)(shadowToken, "color"), shadowOpacity) : shadowToken;
    return {
        shadowColor: shadowColor,
        shadowOpacity: shadowOpacity,
        shadowOffset: {
            width: tokens.shadowOffsetWidth[shadowToken].val,
            height: tokens.shadowOffsetHeight[shadowToken].val
        },
        shadowRadius: tokens.shadowRadius[shadowToken].val,
        elevationAndroid: tokens.elevation[shadowToken].val
    };
};
var getPercentageTokenValue = function(percentageToken) {
    var tokens = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getTokens)();
    return tokens.percentages[percentageToken].val;
};


/***/ }),

/***/ 26217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useObservabilitySafe; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _BricksProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73215);


/**
 * This wrapper hook is added because not every FE app is onboarded to use observability, and observability
 * expects `globalObservability` to have been initialized when `trackJourneyEvent`. Thus, within the
 * scope of `bricks`, we catch any errors of the real `trackJourneyEvent call.
 * Additionally this hook allows us to use the client's version of observability for cases like when we need to use mobile's version of trackJourneyEvent
 * @returns functions trackJourneyEvent
 */ var useObservabilitySafe = function() {
    // This allows use to use the client's version of trackJourneyEvent
    var useObservability = (0,_BricksProvider__WEBPACK_IMPORTED_MODULE_1__/* .useAnalyticsContext */ .Os)().useObservability;
    var ref = useObservability(), actualTrackJourneyEvent = ref.trackJourneyEvent;
    var trackJourneyEvent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return function(categoryName, eventName, eventData, options) {
            try {
                actualTrackJourneyEvent(categoryName, eventName, eventData, options);
            } catch (e) {}
        };
    }, [
        actualTrackJourneyEvent
    ]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            trackJourneyEvent: trackJourneyEvent
        };
    }, [
        trackJourneyEvent
    ]);
};


/***/ })

}]);